// 2025(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import bootstrap from "~bootstrap/dist/js/bootstrap.bundle";

var confirm_modal_count = 0;

const create_confirm_modal = function(callback, args) {
    
    confirm_modal_count += 1;

    let elModal = document.createElement("div");

    elModal.id = 'modal-confirm-container-' + confirm_modal_count;
    elModal.className = "modal fade";
    elModal.setAttribute('tabindex', '-1');

    document.body.appendChild(elModal);

    let title = ('title' in args) ? args['title'] : 'Confirmer';
    let text = ('text' in args) ? args['text'] : '';
    let cancel_label = ('cancel' in args) ? args['cancel'] : 'Annuler';
    let confirm_label = ('confirm' in args) ? args['confirm'] : 'Oui';

    elModal.innerHTML = "<div class=\"modal-dialog modal-dialog-centered\"> \
        <div class=\"modal-dialog\"> \
                <div class=\"modal-content\"> \
                    <div class=\"modal-header\"> \
                        <h5 class=\"modal-title\">" + title + "</h5> \
                        <button type=\"button\" class=\"btn-close\" data-modal-action=\"cancel\" aria-label=\"Close\"></button> \
                    </div> \
                    <div class=\"modal-body\"> \
                        <p class=\"text-center m-0\">" + text + "</p> \
                    </div> \
                    <div class=\"modal-footer\"> \
                        <button type=\"button\" class=\"btn btn-outline-secondary\" data-modal-action=\"cancel\">" + cancel_label + "</button> \
                        <button type=\"button\" class=\"btn btn-primary\" data-modal-action=\"yes\">" + confirm_label + "</button> \
                    </div> \
                </div> \
            </div> \
        </div> \
    ";

    let bsModal = new bootstrap.Modal(elModal, {
        backdrop: 'static',
        keyboard: false
    });

    elModal.addEventListener('hidePrevented.bs.modal', e => {
        let event = {
            modal: elModal,
            action: 'cancel',
        };

        bsModal.hide();

        if (callback !== null)
            callback(event);
    });

    elModal.querySelectorAll('button[data-modal-action]').forEach(el => {
        el.addEventListener("click", function (e) {
            let event = {
                modal: elModal,
                action: e.target.dataset.modalAction,
            };

            bsModal.hide();

            if (callback !== null)
                callback(event);
        });
    });

    return bsModal;
};

export function init() {

    document.querySelectorAll('a.confirm-before').forEach(el => {

        let modal = create_confirm_modal(function(e) {
            if (e.action == 'yes') {
                document.location.href = el.getAttribute('href');
            }
        }, {
            'title': (el.dataset.modalTitle) ? el.dataset.modalTitle : 'Confirmer',
            'text': (el.dataset.modalText) ? el.dataset.modalText : 'Êtes-vous certain de vouloir effectuer cette action ?',
            'confirm': (el.dataset.modalConfirm) ? el.dataset.modalConfirm : 'Oui',
            'cancel': (el.dataset.modalCancel) ? el.dataset.modalCancel : 'Annuler'
        });

        el.addEventListener("click", function(e) {
            e.preventDefault();
            modal.show();
        })

    });

}
